module.exports = __webpack_public_path__ + "cancellara-live-dist/img/logo-header.8fbb3ddf.svg";